

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.5","height":"15.938"}, rest), [h('path', {"d":"M0 6.5h2l2-2v7l-2-2H0zM5 9.5a1.5 1.5 0 0 0 0-3c.016 1.518.009 1.539 0 3Z"}, []), h('path', {"d":"M8.5 8a4 4 0 0 1-3.499 3.969v-1.01a3 3 0 0 0 0-5.917v-1.01A4 4 0 0 1 8.5 8Z"}, [])]);
};

        